export default "__VITE_ASSET__rodixiTh__"